import React from 'react';

const ReviewSupplierScreen = ({ supplierData, setReviewSupplier }) => {
  return (
    <div className="flex">
      <div className="flex flex-col flex-grow overflow-y-auto">
        <div className="pb-7 space-y-3">
          <div className="flex flex-row w-full space-x-3">
            <img
              src={supplierData.supplierImage}
              alt="supplier logo"
              className="rounded-lg w-96 h-[267px]"
            />
            <div className="w-full flex-grow">
              <p className="text-[33px] font-bold mb-2">
                {supplierData.supplier_name}
              </p>
              <div className="min-w-screen">
                <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl">
                  <div className="font-light tracking-tight text-gray-900 text-[25px]">
                    Rating
                  </div>
                  <div className="flex">
                    <div className="flex-col w-full">
                      <div className="grid grid-cols-4 mt-5 items-center">
                        <div className="text-black text-[18px] text-left font-bold">
                          Quality :
                        </div>
                      </div>
                      <div className="grid grid-cols-4 mt-5 items-center">
                        <div className="text-black text-[18px] text-left font-bold">
                          Delivery :
                        </div>
                      </div>
                      <div className="grid grid-cols-4 mt-5 items-center">
                        <div className="text-black text-[18px] text-left font-bold">
                          Communication :
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full min-w-screen">
            <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl">
              <div className="font-light tracking-tight text-gray-900 text-[25px]">
                Capacity and Availability
              </div>
              <div className="flex">
                <div className="flex-col w-full">
                  <div className="grid grid-cols-4 mt-5 items-center">
                    <div className="text-black text-[18px] text-left font-bold">
                      Capacity :
                    </div>
                  </div>
                  <div className="grid grid-cols-4 mt-5 items-center">
                    <div className="text-black text-[18px] text-left font-bold">
                      Availability: :
                    </div>
                  </div>
                  <div className="grid grid-cols-4 mt-5 items-center">
                    <div className="text-black text-[18px] text-left font-bold">
                      Material :
                    </div>
                  </div>
                  <div className="grid grid-cols-4 mt-5 items-center">
                    <div className="text-black text-[18px] text-left font-bold">
                      Process :
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full min-w-screen">
            <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl">
              <div className="font-light tracking-tight text-gray-900 text-[25px]">
                Capabilities
              </div>
              <div className="flex">
                <div className="flex-col w-full">
                  <div className="grid grid-cols-4 mt-5 items-center">
                    <div className="text-black text-[18px] text-left font-bold">
                      Types :
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full min-w-screen">
            <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl">
              <div className="font-light tracking-tight text-gray-900 text-[25px]">
                Dimensions and Inspection
              </div>
              <div className="flex">
                <div className="flex-col w-full">
                  <div className="grid grid-cols-4 mt-5 items-center">
                    <div className="text-black text-[18px] text-left font-bold">
                      Part Dimension :
                    </div>
                  </div>
                  <div className="grid grid-cols-4 mt-5 items-center">
                    <div className="text-black text-[18px] text-left font-bold">
                      Part Weight :
                    </div>
                  </div>
                  <div className="grid grid-cols-4 mt-5 items-center">
                    <div className="text-black text-[18px] text-left font-bold">
                      Inspection Capabilities :
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full min-w-screen">
            <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl">
              <div className="font-light tracking-tight text-gray-900 text-[25px]">
                Certificates
              </div>
              <div className="flex">
                <div className="flex-col w-full">
                  <div className="grid grid-cols-4 mt-5 items-center">
                    <div className="text-black text-[18px] text-left font-bold">
                      Title :
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full min-w-screen">
            <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl">
              <div className="font-light tracking-tight text-gray-900 text-[25px]">
                Videos/Photos
              </div>
              <div className="flex">
                <div className="flex-col w-full">
                  <div className="grid grid-cols-4 mt-5 items-center">
                    <div className="text-black text-[18px] text-left font-bold">
                      Title :
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full min-w-screen">
            <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl">
              <div className="font-light tracking-tight text-gray-900 text-[25px]">
                Location
              </div>
              <div className="flex">
                <div className="flex-col w-full">
                  <div className="grid grid-cols-4 mt-5 items-center">
                    <div className="w-[415px] h-[177px] bg-neutral-300 rounded-xl"></div>
                    <p className="col-start-3 text-l font-bold">
                      <span
                        style={{
                          wordWrap: 'break-word',
                        }}
                      >
                        {supplierData.location}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-row items-center justify-center space-x-4">
            <button
              className="rounded-full px-8 py-2 text-[18px] font-bold text-left my-1 bg-blue-400 text-white"
              onClick={() => setReviewSupplier(null)}
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewSupplierScreen;
